import { motion } from 'framer-motion';
import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    
    // 이메일 본문 구성
    const subject = encodeURIComponent(`[문의] ${formData.name}님의 프로젝트 문의`);
    const body = encodeURIComponent(
      `이름: ${formData.name}\n` +
      `이메일: ${formData.email}\n` +
      `회사명: ${formData.company || '(없음)'}\n\n` +
      `프로젝트 설명:\n${formData.message}`
    );
    
    // 메일 클라이언트 열기
    window.location.href = `mailto:cheezemoonstudio@gmail.com?subject=${subject}&body=${body}`;
    
    // 폼 초기화
    setFormData({ name: '', email: '', company: '', message: '' });
  };

  const handleNewsletterSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setNewsletterStatus('loading');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', newsletterEmail);

      const response = await fetch('https://readdy.ai/api/form/d5gh1sj48noljcu3pi7g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setNewsletterStatus('success');
        setNewsletterEmail('');
        setTimeout(() => setNewsletterStatus('idle'), 3000);
      } else {
        setNewsletterStatus('error');
        setTimeout(() => setNewsletterStatus('idle'), 3000);
      }
    } catch (error) {
      setNewsletterStatus('error');
      setTimeout(() => setNewsletterStatus('idle'), 3000);
    }
  };

  return (
    <section id="contact" className="bg-black">
      <div className="py-32 px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-20"
          >
            <h2 className="text-white font-bold mb-6" style={{ fontSize: '60px', lineHeight: '1.2', fontFamily: 'Bebas Neue, sans-serif' }}>
              Let's Create
            </h2>
            <p className="text-gray-400 text-xl">
              프로젝트 문의부터 제작까지, 모든 과정을 함께합니다
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="max-w-3xl mx-auto"
          >
            <form id="contact-form" onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-gray-300 text-sm mb-2">이름</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-amber-600 transition-colors"
                    placeholder="홍길동"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-gray-300 text-sm mb-2">이메일</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-amber-600 transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="company" className="block text-gray-300 text-sm mb-2">회사명</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-amber-600 transition-colors"
                  placeholder="회사명 (선택사항)"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-gray-300 text-sm mb-2">프로젝트 설명</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => {
                    if (e.target.value.length <= 500) {
                      setFormData({ ...formData, message: e.target.value });
                    }
                  }}
                  required
                  rows={6}
                  maxLength={500}
                  className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-amber-600 transition-colors resize-none"
                  placeholder="프로젝트에 대해 자세히 알려주세요..."
                />
                <p className="text-gray-500 text-xs mt-2">{formData.message.length}/500</p>
              </div>
              <button
                type="submit"
                className="w-full bg-amber-600 text-white px-8 py-4 rounded-lg font-medium hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                문의하기
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
